// extracted by mini-css-extract-plugin
export default {"tableCell":"FaqTableRow_tableCell__vxLUx","opacityText":"FaqTableRow_opacityText__e5Ewi","buttonsContainer":"FaqTableRow_buttonsContainer__lWf20"};